<template>
    <div :class="{
        hover_cell: true,
        higlight_cell: (current_row_index >= row_index) && (current_item_index >= item_index),
    }"
        @click="$parent.set_template(row_index, item_index)"
        @mouseover="$parent.set_current(row_index, item_index)">
    </div>
</template>

<script>

export default {
    components: {
    },
    props: {
        current_row_index: {
            type: Number,
            default: 0
        },
        current_item_index: {
            type: Number,
            default: 0
        },
        row_index: {
            type: Number,
            default: 0
        },
        item_index: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            is_initialized: false,
            is_processing: true,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },

}
</script>

<style scoped lang="scss">
.hover_cell {
    border: 2px solid #4b67a1;
    height: 25px;
    width: 25px;
    margin: 0 1px 1px 0;
    float: left;
    cursor: pointer;
}
.hover_cell:hover, .hover_cell_hover {
    background-color: #4b67a1;
}
.hover_cell {
    border: 1px solid #aaa;
}
.higlight_cell {
    background-color: #d1e0ff;
}
</style>
